// styles
import { themeOptions } from 'styles';

// libraries
import styled from 'styled-components';
import { FormControl } from '@mui/material';

export const StyledFormControl = styled(FormControl)`
  .MuiFormGroup-root {
    display: flex;
    gap: 16px;
  }

  .MuiFormControlLabel-root {
    margin: 0;

    &:hover {
      background-color: #f5f5f5;
    }

    &.Mui-checked {
      border-color: ${themeOptions.palette.green.main};
      background-color: rgba(0, 0, 0, 0.04);
    }
  }

  .MuiRadio-root {
    padding: 4px;

    &.Mui-checked {
      color: ${themeOptions.palette.green.main};
    }
  }
`;
